import React, { useState } from 'react';

export default function QuickAddModal({ onClose, onCreate }) {
    const [shiftType, setShiftType] = useState('Day');
    const [is24Hour, setIs24Hour] = useState(false);
    const [startTime, setStartTime] = useState('09:00');
    const [endTime, setEndTime] = useState('17:00');

    const handleCreate = () => {
        if (!startTime || !endTime) {
            alert('Please provide start and end times.');
            return;
        }
        onCreate({ type: shiftType, is24Hour, startTime, endTime });
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={styles.header}>
                    <h2 style={styles.title}>Quick add today</h2>
                </div>
                
                <div style={styles.content}>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Shift type</label>
                        <select 
                            style={styles.input}
                            value={shiftType}
                            onChange={(e) => setShiftType(e.target.value)}
                        >
                            <option value="Day">Day</option>
                            <option value="Night">Night</option>
                            <option value="Live-in">Live-in</option>
                        </select>
                    </div>

                    <div style={{ margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontSize: '14px', color: '#374151' }}>24 hour / live-in style shift</span>
                        <input 
                            type="checkbox" 
                            checked={is24Hour}
                            onChange={(e) => setIs24Hour(e.target.checked)}
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Start time e.g. 09:00 AM</label>
                        <input 
                            type="time" 
                            style={styles.input}
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                        />
                    </div>
                    
                    <div style={{ ...styles.inputGroup, marginTop: '20px' }}>
                        <label style={styles.label}>End time e.g. 05:00 PM</label>
                        <input 
                            type="time" 
                            style={styles.input}
                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                        />
                    </div>
                </div>

                <div style={styles.footer}>
                    <button onClick={onClose} style={styles.cancelBtn}>Cancel</button>
                    <button onClick={handleCreate} style={styles.createBtn}>Create</button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
        justifyContent: 'center', alignItems: 'center', zIndex: 1000
    },
    modal: {
        backgroundColor: 'white', borderRadius: '12px', width: '90%', maxWidth: '400px',
        boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)', overflow: 'hidden'
    },
    header: {
        padding: '24px 24px 16px', borderBottom: '1px solid #e5e7eb'
    },
    title: {
        margin: 0, fontSize: '18px', color: '#111827', fontWeight: 'bold'
    },
    content: {
        padding: '24px'
    },
    inputGroup: {
        display: 'flex', flexDirection: 'column', position: 'relative'
    },
    label: {
        position: 'absolute', top: '-8px', left: '8px', backgroundColor: 'white', 
        padding: '0 4px', fontSize: '11px', color: '#6b7280'
    },
    input: {
        padding: '12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none',
        width: '100%', boxSizing: 'border-box'
    },
    footer: {
        padding: '16px 24px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: '12px'
    },
    cancelBtn: {
        padding: '8px 16px', border: 'none', background: 'none', color: '#2563eb', fontWeight: '500', cursor: 'pointer'
    },
    createBtn: {
        padding: '8px 16px', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', fontWeight: '500', cursor: 'pointer'
    }
};
